/**
 * Function for sending event data to backend
 */
export var sendWithBeacon = function (destinationUrl) {
    return function (event) {
        var eventBlob = new Blob([JSON.stringify(event)], {
            type: "'application/vnd.sparebank1.v1+json; charset=utf-8'",
        });
        return navigator.sendBeacon
            ? navigator.sendBeacon(destinationUrl, eventBlob)
            : sendWithXhr(destinationUrl, eventBlob); // Fail-safe for browser support
    };
};
var sendWithXhr = function (url, data) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.withCredentials = true;
    xhr.setRequestHeader('Accept', '*/*');
    xhr.setRequestHeader('Content-Type', data.type);
    try {
        xhr.send(data);
        return true;
    }
    catch (error) {
        console.warn('Tracking error: ' + error);
        return false;
    }
};
//# sourceMappingURL=sendWithBeacon.js.map